import { useState } from 'react';
import { api } from './api';

interface Props { onAuthed: () => void; }

export function Login({ onAuthed }: Props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api.post('/api/admin/login', { username, password });
      onAuthed();
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center">
      <div className="panel auth-card">
        <h2 style={{ marginTop: 0 }}>Admin</h2>
        <form onSubmit={submit}>
          <div className="field">
            <label>Username</label>
            <input
              autoCapitalize="none" autoCorrect="off" autoComplete="username"
              value={username} onChange={(e) => setUsername(e.target.value)}
              style={{ width: '100%' }} required
            />
          </div>
          <div className="field">
            <label>Password</label>
            <input
              type="password" autoComplete="current-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              style={{ width: '100%' }} required
            />
          </div>
          {err && <div className="field error">{err}</div>}
          <button type="submit" disabled={busy}>{busy ? '…' : 'Sign in'}</button>
        </form>
      </div>
    </div>
  );
}
